import POAExtensionRecord from '@/entities/POAExtensionRecord';
import axios, {AxiosResponse} from 'axios';

export const POAExtensionService = {
    search,
};

function search(name: string, ticket: string): Promise<AxiosResponse<POAExtensionRecord[]>> {
    if (typeof name === 'undefined' || name === null || name.length === 0 || typeof ticket === 'undefined'
        || ticket === null || ticket.length === 0) {
        return Promise.reject();
    }
    return axios.get<POAExtensionRecord[]>(`${process.env.VUE_APP_POA_SERVICE}?name=${name}&ticket=${ticket}`);
}
